import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ["form", "select", "noResultText", "financePlatformImage", "financePlatformApr", "estimatedReturn", "earnDropdownCoins", "invalidInputText", "searchInput", "financePlatform", "calculatorInput", "calculatorSubmitButton", "collapseContent", "toggleSelectCoinsModalCaret", "calculatorContainer", "initialInvestmentValueUsd"];

  submitFilterForm() {
    this.formTarget.submit();
  }

  changeCaret(e) {
    let caret = e.target
    // let isContentCollapsed = !this.collapseContentTarget.classList.contains('show')
    if(caret.classList.contains('fa-angle-down')){
      caret.classList.remove('fa-angle-down')
      caret.classList.add('fa-angle-up')
    } else {
      caret.classList.remove('fa-angle-up')
      caret.classList.add('fa-angle-down')
    }
  }

  search() {
    const userInput = this.searchInputTarget.value
    this._showSearchResults(userInput)
  }

  toggleSelectCoinsModal() {
    let selectCoinsModal = document.getElementById("earn-modal-wrapper");
    if (selectCoinsModal.classList.contains("tw-hidden")) {
      selectCoinsModal.classList.remove('tw-hidden');
    }else{
      selectCoinsModal.classList.add('tw-hidden');
    }

    if(this.toggleSelectCoinsModalCaretTarget.classList.contains("fa-angle-down")){
      this.toggleSelectCoinsModalCaretTarget.classList.remove("fa-angle-down")
      this.toggleSelectCoinsModalCaretTarget.classList.add("fa-angle-up")
    }else if (this.toggleSelectCoinsModalCaretTarget.classList.contains("fa-angle-up")){
      this.toggleSelectCoinsModalCaretTarget.classList.remove("fa-angle-up")
      this.toggleSelectCoinsModalCaretTarget.classList.add("fa-angle-down")
    }
  }

  calculateAPR() {
    let calculatorInput = this._getCalculatorInput();
    let financePlatformApr = this.financePlatformAprTarget;
    let estimatedReturnElements = this.estimatedReturnTarget.children;

    this._calculateInitialInvestmentUsd(calculatorInput)
    this._calculateAllApr(calculatorInput, financePlatformApr);
    this._changeEarnCalculatorButton(calculatorInput);
  }

  selectedFinancePlatform() {
    let financePlatformId = Number(this.financePlatformTarget.value);
    let financePlatformDetails = JSON.parse(this.financePlatformTarget.dataset.details)
    let targetedFinancePlatform = financePlatformDetails.find(element => element[0] === financePlatformId);
    let financePlatformImage = this.financePlatformImageTarget;
    let financePlatformApr = this.financePlatformAprTarget;


    financePlatformImage.src = targetedFinancePlatform[3];
    financePlatformApr.innerText = targetedFinancePlatform[1];
    this.calculatorSubmitButtonTarget.parentElement.href = targetedFinancePlatform[4];
    this.calculateAPR()
  };

  _showSearchResults(userInput) {
    if(userInput === ""){
      this._showAll(this.earnDropdownCoinsTargets)
    } else {
      this._hideAll(this.earnDropdownCoinsTargets)
      this._findMatchingResults(userInput)
    }
    this._showNoSearchResultsText();
   }

  _findMatchingResults(userInput) {
    let earnDropdownCoins = this.earnDropdownCoinsTargets;
    for (var i = 0; i < earnDropdownCoins.length; i++) {
      var coin = earnDropdownCoins[i];
      var userInputLowerCase = userInput.toLowerCase()
      var coinName = coin.dataset["coinName"].toLowerCase()
      if(!coinName.includes(userInputLowerCase)){
        coin.classList.add('tw-hidden')
      } else{
        coin.classList.remove('tw-hidden')
      }
    }
  }

  _hideAll(elements) {
    for (let i = 0; i < elements.length; i++) {
      let element = elements[i];
      element.classList.add('tw-hidden')
    }
   }

  _showAll(elements) {
    for (let i = 0; i < elements.length; i++) {
      let element = elements[i];
      element.classList.remove('tw-hidden')
    }
   }

  _showNoSearchResultsText() {
    let matchingCoin = []
    let earnDropdownCoins = this.earnDropdownCoinsTargets
    for (let i = 0; i < earnDropdownCoins.length; i++) {
      let coin = earnDropdownCoins[i];
      if(!coin.classList.contains('tw-hidden')){
        matchingCoin.push(coin)
      }
    }

    if(matchingCoin.length == 0) {
      this.noResultTextTarget.classList.remove('tw-hidden')
    } else {
      this.noResultTextTarget.classList.add('tw-hidden')
    }
 }

  _changeEarnCalculatorButton() {
    let calculatorSubmitButton = this.calculatorSubmitButtonTarget
    calculatorSubmitButton.disabled = false;
    calculatorSubmitButton.classList.remove("earn-calculator-button-background");
  };

  _getCalculatorInput() {
    let initialInputValue = 100;
    if(this.calculatorInputTarget.value != ""){
      return this.calculatorInputTarget.value;
    }
    return initialInputValue;
  }

  _calculateAllApr(calculatorInput, financePlatformApr) {
    let coinPriceUsd = this.calculatorContainerTarget.dataset["coinPriceUsd"];
    let estimatedReturnElements = this.estimatedReturnTarget.children
    let coinName = this.estimatedReturnTarget.dataset.coinName
    const days_in_a_year = 365;

    if(isNaN(calculatorInput)){
      let invalidInputText = this.invalidInputTextTarget;
      invalidInputText.classList.remove('tw-hidden');
    } else {
      for (let i = 0; i < estimatedReturnElements.length; i++) {
        let estimatedReturn = estimatedReturnElements[i];
        let investmentYears = Number(estimatedReturn.dataset.duration) / 12;
        let apr = parseFloat(financePlatformApr.innerText) / 100;
        let divisor = 1 + apr / days_in_a_year;
        let denominator = days_in_a_year * investmentYears;
        let multiplier = Math.pow(divisor, denominator);
        let estimatedFinalValue = parseFloat(calculatorInput) * multiplier;
        let estimatedFinalValueUsd = estimatedFinalValue * coinPriceUsd;
        let estimatedEarning = estimatedFinalValue - calculatorInput;
        estimatedReturn.firstElementChild.innerHTML =
          `<h6 class="font-weight-bold mb-0">${coinName} <span class="text-primary">${parseFloat(estimatedFinalValue.toFixed(2)).toLocaleString()}</span>
          <small>(+${estimatedEarning.toFixed(2)})</small></h6>
          <div class="text-muted text-xs font-weight-normal mt-1">$${parseFloat(estimatedFinalValueUsd.toFixed(2)).toLocaleString()}</div>`;
      }
    }
  }

  _calculateInitialInvestmentUsd(calculatorInput) {
    let coinPriceUsd = this.calculatorContainerTarget.dataset["coinPriceUsd"];
    if(calculatorInput != ""){
      var initialInvestmentValueUsd = calculatorInput * coinPriceUsd
    } else {
      var initialInvestmentValueUsd = 100 * coinPriceUsd;
    }
    this.initialInvestmentValueUsdTarget.innerText = `$${parseFloat(initialInvestmentValueUsd.toFixed(2)).toLocaleString()}`
  }
}
